var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.5 3.85a1.65 1.65 0 1 0 0 3.3h1.65V5.5A1.65 1.65 0 0 0 9.5 3.85m2.823-.155a3.35 3.35 0 0 0-5.74 3.455H5a2.85 2.85 0 0 0-.85 5.571V19A2.85 2.85 0 0 0 7 21.85h10A2.85 2.85 0 0 0 19.85 19v-6.279A2.851 2.851 0 0 0 19 7.15h-2.392a2.85 2.85 0 0 0-4.286-3.455M12.85 6v1.15H14A1.15 1.15 0 1 0 12.85 6m-1.7 2.85H5a1.15 1.15 0 0 0 0 2.3h6.15zm0 4h-5.3V19c0 .635.515 1.15 1.15 1.15h4.15zm1.7 7.3v-7.3h5.3V19A1.15 1.15 0 0 1 17 20.15zm0-9v-2.3H19a1.15 1.15 0 0 1 0 2.3z",
  clipRule: "evenodd"
})));
export default SvgGift;